import styled from 'styled-components';
import { Box } from '..';
import { getColor } from '../../styles/mixins';
import { TableNodeStyleI } from '../../types/table';
import { Cross2Icon } from '@modulz/radix-icons';

interface DeleteIconProps {
  showDeleteTableIcon: boolean;
}

export const TableNodeStyle = styled(Box)<TableNodeStyleI>`
  font-weight: 500;
  font-size: 22px;
  cursor: pointer;
  width: auto;
  height: auto;
  min-width: 200px;
  min-height: 40px;
  border-radius: 8px;
  border: 2px solid ${({ nodeColor }) => getColor(nodeColor)};
  background-color: ${({ nodeColor }) => getColor(nodeColor, 100)};
  color: ${({ nodeColor }) => getColor(nodeColor)};
`;

export const DeleteNode = styled(Box)`
  height: 20px;
  width: 20px;
  color: ${getColor('gray', 0)};
  margin-left: auto;
  margin-right: -8px;
  margin-bottom: -8px;
  cursor: pointer;
`;

export const DeleteIcon = styled(Cross2Icon)`
  height: 20px;
  width: 20px;
  background-color: ${getColor('red')};
  border-radius: 12px;
  padding: 2px;
  visibility: ${({ showDeleteTableIcon }: DeleteIconProps) =>
    showDeleteTableIcon ? 'visible' : 'hidden'};
`;
